export default __webpack_public_path__ + "static/media/icon-insights-free-delivery.3937b51f.svg";